function sessionChangedError() {
  const error = new Error('登录账号已切换')
  error.code = 'SESSION_CHANGED'
  return error
}

function createRefreshCoordinator ({ refresh, save, clear = () => {}, sessionVersion = () => 0 }) {
  let inFlight = null

  return {
    run () {
      const version = sessionVersion()
      if (!inFlight || inFlight.version !== version) {
        const flight = { version, promise: null }
        inFlight = flight
        const ensureCurrent = () => {
          if (sessionVersion() !== version) throw sessionChangedError()
        }
        flight.promise = Promise.resolve()
          .then(() => { ensureCurrent(); return refresh() })
          .then(data => {
            ensureCurrent()
            save(data)
            return data
          })
          .catch(error => {
            if (sessionVersion() !== version) throw sessionChangedError()
            clear()
            throw error
          })
          .finally(() => {
            if (inFlight === flight) inFlight = null
          })
      }
      return inFlight.promise
    }
  }
}

module.exports = { createRefreshCoordinator, sessionChangedError }
